import React, { Component, Suspense, lazy } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import Home from './components/Home';
import NotFound from './components/NotFound';
import RouteSeo from './components/RouteSeo';

const AboutMe = lazy(() => import('./components/AboutMe'));
const Contact = lazy(() => import('./components/Contact'));
const Portfolio = lazy(() => import('./components/Portfolio'));
const Manifesto = lazy(() => import('./components/Manifesto'));
const Privacy = lazy(() => import('./components/Privacy'));
const Services = lazy(() => import('./components/Services'));

class Routes extends Component {
  render() {
    return (
      <>
        <RouteSeo />
        <Suspense fallback={null}>
          <Switch>
            <Route exact path="/" component={Home} />
            <Redirect exact from="/home" to="/" />
            <Route exact path="/aboutMe" component={AboutMe} />
            <Route exact path="/services" component={Services} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/portfolio" component={Portfolio} />
            <Route exact path="/manifesto" component={Manifesto} />
            <Route exact path="/privacy" component={Privacy} />
            <Route component={NotFound} />
          </Switch>
        </Suspense>
      </>
    );
  }
}

export default withRouter(Routes);
